<main class="relative flex flex-col pb-6 pt-14 lg:pt-18">
  <!-- 배경 이미지 -->
  <div class="relative w-full">
    <img src="/event/top-bg-mo.svg" alt="top background" class="w-full flex lg:hidden" />
    <img src="/event/top-bg-pc.svg" alt="top background" class="w-full hidden lg:flex" />
    <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-4">
      <p class="sb-aggro text-white/40 font-light text-xs">홈 > 방송 홍보 제휴 문의</p>
      <h1 class="text-white text-2xl lg:text-4xl">방송 홍보 제휴 문의</h1>
      <p class="text-zinc-400 font-medium">브랜드를 알릴 수 있는 최적의 홍보 솔루션을 제안합니다.</p>
    </div>
  </div>

  <section class="flex flex-col w-full max-w-6xl mx-auto py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
    <div class="flex flex-col lg:flex-row gap-6 lg:gap-10">
      <div class="flex flex-col gap-3 justify-start lg:min-w-[300px]">
        <h1 class="text-zinc-800 text-xl">
          소통과 가치창조로<br />
          고객과 함께 미래를 선도합니다
        </h1>
        <p class="text-zinc-400 font-medium text-sm lg:text-base">
          문의를 남겨주시면 담당자가 확인 후 빠르고 신속하게답변드리겠습니다.
        </p>
      </div>

      <form [formGroup]="form" class="w-full">
        <div class="flex flex-col gap-6">
          <div class="flex flex-col gap-6 border border-zinc-100 rounded-2xl p-5 bg-white">
            <app-fieldset label="이름" required>
              <input type="text" formControlName="name" class="input w-full" placeholder="입력해주세요" />
            </app-fieldset>

            <app-fieldset label="연락처" required>
              <input
                type="text"
                formControlName="contact"
                appFormatInput="phone"
                placeholder="010-1234-5678"
                maxlength="13"
                class="input w-full" />
            </app-fieldset>

            <app-fieldset label="제목" required>
              <input type="text" formControlName="title" class="input w-full" placeholder="입력해주세요" />
            </app-fieldset>

            <app-fieldset class="relative" label="문의내용" required>
              <textarea
                formControlName="content"
                class="input w-full min-h-[100px]"
                placeholder="입력해주세요"
                maxlength="1000"
                style="white-space: normal"></textarea>
              <div class="absolute bottom-4 right-2 text-sm text-zinc-300 z-10">
                {{ form.controls.content.value.length }}/1000
              </div>
            </app-fieldset>
            <button
              type="button"
              (click)="submitInquiry()"
              [disabled]="form.invalid"
              class="sb-aggro font-light cursor-pointer flex-1 bg-primary-500 text-white rounded-lg p-3 lg:py-2 lg:px-3 disabled:bg-zinc-200 disabled:cursor-not-allowed">
              문의하기
            </button>
          </div>
        </div>
      </form>
    </div>
  </section>
</main>
